import React from 'react';

const spinner = (props) => {
    return (
        <div className="text-center text-success body-spinner" style={{ ...styles, display: props.display || 'flex' }}>
            <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
            </div>
            <p className="mt-2">Loading ...</p>
        </div>

    )
}
const styles = {
    position: "fixed",
    zIndex: 99999,
    left: 0,
    top: 0,
    width: "100vw",
    height: "100vh",
    background: "rgba(255, 255, 255, 0.4)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: 'column'
}

export default spinner;